export default __webpack_public_path__ + "static/media/display-alt.e0d27328.svg";